import Menu from 'features/common/components/Menu'

import arrowBottom from 'assets/arrow-bottom-wide-white.svg'
import arrowTop from 'assets/arrow-top-wide-white.svg'

import useLanguageSelect from 'features/common/hooks/useLanguageSelect'

const LanguageSelect = () => {
    const {language, languageList, onChangeLanguage} = useLanguageSelect()

    return (
        <Menu as="div" className="relative flex-1">
            <Menu.Button as="div" className="flex items-center gap-3">
                {({open}) => (
                    <>
                        <span className="cursor-pointer">
                            {language.toUpperCase()}
                        </span>
                        <button className="flex items-center">
                            <img
                                src={open ? arrowTop : arrowBottom}
                                alt="open"
                            />
                        </button>
                    </>
                )}
            </Menu.Button>
            <Menu.Items className="absolute right-0 top-full z-10 flex w-max flex-col gap-5 rounded-lg bg-yellow-40 p-4 text-xl text-white">
                {languageList.map((l) => {
                    if (l === language) {
                        return null
                    }
                    return (
                        <Menu.Item key={l}>
                            <button
                                className="flex gap-3"
                                onClick={() => onChangeLanguage(l)}
                            >
                                <div>{l.toUpperCase()}</div>
                            </button>
                        </Menu.Item>
                    )
                })}
            </Menu.Items>
        </Menu>
    )
}

export default LanguageSelect
